import { useCallback, useState } from "react"
import { FormState } from "../component/ScheduleForm"
import { ScheduleType } from "../model/ChecklistDtos"
import { ScheduleValidator } from "../service/scheduleFormValidator"

export const useScheduleValidation = (currentScheduleInitialData?: Partial<FormState>) => {
    const [validationErrors, setValidationErrors] = useState<Record<string, string>>({})

    const validate = useCallback((): boolean => {
        const errors: Record<string, string> = {}

        if (!currentScheduleInitialData) return false

        if (!currentScheduleInitialData.idChecklist) errors.idChecklist = "Checklist is required"
        if (!currentScheduleInitialData.enableRepeat) ScheduleValidator.validateOnceSchedule(currentScheduleInitialData, errors)
        if (currentScheduleInitialData.repeatType === ScheduleType.Daily) ScheduleValidator.validateDailySchedule(currentScheduleInitialData, errors)
        if (currentScheduleInitialData.repeatType === ScheduleType.Weekly) ScheduleValidator.validateWeeklySchedule(currentScheduleInitialData, errors)
        if (currentScheduleInitialData.repeatType === ScheduleType.FourWeekly) ScheduleValidator.validateFourWeeklySchedule(currentScheduleInitialData, errors)
        if (currentScheduleInitialData.repeatType === ScheduleType.Monthly) ScheduleValidator.validateMonthlySchedule(currentScheduleInitialData, errors)

        setValidationErrors(errors)
        return Object.keys(errors).length === 0
    }, [currentScheduleInitialData])

    const clearValidation = useCallback((keys?: (keyof FormState)[]) => {
        if (!keys) {
            setValidationErrors({})
            return
        }

        setValidationErrors((prev) => {
            const updated = { ...prev }
            keys.forEach((key) => delete updated[key])
            return updated
        })
    }, [])

    return { validationErrors, validate, clearValidation }
}